import type { Meta, StoryFn } from '@storybook/react';

import { ThemeOverride, Status, cap } from '@pega/cosmos-react-core';
import type { StatusProps } from '@pega/cosmos-react-core';

export default {
  component: Status,
  title: 'Core/Badges/Status',
  excludeStories: ['ConfigurableStatusBadge']
} as Meta;

export const StatusBadge: StoryFn<StatusProps> = (args: StatusProps) => {
  return <Status variant={args.variant}>{cap(args.variant)}</Status>;
};

StatusBadge.args = {
  variant: 'success'
};

StatusBadge.argTypes = {
  variant: {
    options: ['success', 'urgent', 'warn', 'pending', 'info'],
    control: { type: 'select' }
  }
};

interface ConfigurableStatusBadgeProps {
  foreground?: string;
  background?: string;
}

export const ConfigurableStatusBadge: StoryFn<ConfigurableStatusBadgeProps> = (
  args: ConfigurableStatusBadgeProps
) => {
  return (
    <ThemeOverride
      theme={{
        components: {
          badges: {
            status: {
              success: {
                foreground: args.foreground,
                background: args.background
              }
            }
          }
        }
      }}
    >
      <Status variant='success'>Configurable Success</Status>
    </ThemeOverride>
  );
};

ConfigurableStatusBadge.args = {
  foreground: '#156f35',
  background: '#d4f7d5'
};

ConfigurableStatusBadge.argTypes = {
  foreground: { control: { type: 'color' } },
  background: { control: { type: 'color' } }
};
